module.exports = __webpack_public_path__ + "static/media/launch_icon.77b10af7.png";